/**
 * Returns the video duration in display format such as 1K, 1M...
 *
 * @param {number} videoDuration
 * @returns {string|null}
 */
export var getVideoDurationInDisplayFormat = function (videoDuration) {
    if (!videoDuration && videoDuration !== 0)
        return null;
    if (videoDuration < 1000) {
        return videoDuration.toString();
    }
    if (videoDuration < 1000000) {
        return videoDuration / 1000 + "K";
    }
    return videoDuration / 1000000 + "M";
};
/**
 * Returns the video duration to show in videos
 *
 * @param {number} totalSeconds
 * @returns {string}
 */
export var getVideoDuration = function (totalSeconds) {
    var hours = Math.floor(totalSeconds / 3600);
    var ss = totalSeconds % 3600;
    var minutes = Math.floor(ss / 60);
    var seconds = ("0" + Math.floor(ss % 60)).substr(-2);
    if (!!hours) {
        return hours + ":" + minutes + ":" + seconds;
    }
    if (!!minutes) {
        return minutes + ":" + seconds;
    }
    return "0:" + seconds;
};



//////////////////
// WEBPACK FOOTER
// ./src/utils/cards.ts
// module id = 420
// module chunks = 81